import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useEffectiveAccess } from '@/lib/effectiveAccess';
import * as intakeApi from '../intake.api';

/**
 * h6-4 — de orderstatus van één aanmelding.
 *
 * Blijft verversen zolang het scherm openstaat: de processtappen komen van een andere kant en
 * kunnen elk moment binnenkomen. Zonder dat blijft een klant naar "Ontvangen" kijken terwijl de
 * volgende stap er al is, en zelf verversen is precies wat je niet wilt dat hij moet bedenken.
 */
const ORDERSTATUS_POLL_INTERVAL_MS = 30_000;

export const INTAKE_ORDER_STATUS_QUERY_KEY = ['intake', 'orderStatus'] as const;

export function useIntakeOrderStatus(orderNumber: string | null) {
  const { i18n } = useTranslation();
  const { isSimulating, simulatedGln } = useEffectiveAccess();
  // Kijkt een medewerker mee via "bekijk als", dan moet het klantnummer mee. Een interne rol gaat
  // ongefilterd door de afscherming heen; zonder dat nummer weigert de achterkant het verzoek — en
  // dan zou het scherm melden dat de aanmelding niet bestaat.
  const gln = isSimulating ? simulatedGln : null;

  return useQuery({
    queryKey: [...INTAKE_ORDER_STATUS_QUERY_KEY, orderNumber, i18n.language, gln],
    queryFn: () => intakeApi.getIntakeOrderStatus(orderNumber!, { language: i18n.language, gln }),
    enabled: !!orderNumber,
    refetchInterval: ORDERSTATUS_POLL_INTERVAL_MS,
  });
}
